import { render, staticRenderFns } from "./TablePaginationPage.vue?vue&type=template&id=19764d82&scoped=true&"
import script from "./TablePaginationPage.vue?vue&type=script&lang=js&"
export * from "./TablePaginationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19764d82",
  null
  
)

export default component.exports